// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    PaFollowUpPaFollowUpPriorAuthorizationFollowUpDefaultResponse,
    PaFollowUpPaFollowUpPriorAuthorizationFollowUpRequestSearchDefaultResponse,
    PaFollowUpPaFollowUpPriorAuthorizationFollowUpResultSearchDefaultResponse,
    PriorAuthorizationFollowUpRequest,
    PriorAuthorizationFollowUpRequestSearchRequest,
    PriorAuthorizationFollowUpResultSearchRequest,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgePaFollowUpApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param priorAuthorizationFollowUpRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async paFollowUpPriorAuthorizationFollowUp (priorAuthorizationFollowUpRequest: PriorAuthorizationFollowUpRequest, xProgramId?: string): Promise<AxiosResponse<PaFollowUpPaFollowUpPriorAuthorizationFollowUpDefaultResponse>> {
        const _url_ = '/edge/paFollowUp/PriorAuthorizationFollowUp';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'priorAuthorizationFollowUpRequest' is not null or undefined
        if (priorAuthorizationFollowUpRequest === null || priorAuthorizationFollowUpRequest === undefined) {
            throw new Error('Required parameter priorAuthorizationFollowUpRequest was null or undefined when calling paFollowUpPriorAuthorizationFollowUp.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(priorAuthorizationFollowUpRequest, "PriorAuthorizationFollowUpRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PaFollowUpPaFollowUpPriorAuthorizationFollowUpDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PaFollowUpPaFollowUpPriorAuthorizationFollowUpDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param priorAuthorizationFollowUpRequestSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async paFollowUpPriorAuthorizationFollowUpRequestSearch (priorAuthorizationFollowUpRequestSearchRequest: PriorAuthorizationFollowUpRequestSearchRequest, xProgramId?: string): Promise<AxiosResponse<PaFollowUpPaFollowUpPriorAuthorizationFollowUpRequestSearchDefaultResponse>> {
        const _url_ = '/edge/paFollowUp/PriorAuthorizationFollowUpRequestSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'priorAuthorizationFollowUpRequestSearchRequest' is not null or undefined
        if (priorAuthorizationFollowUpRequestSearchRequest === null || priorAuthorizationFollowUpRequestSearchRequest === undefined) {
            throw new Error('Required parameter priorAuthorizationFollowUpRequestSearchRequest was null or undefined when calling paFollowUpPriorAuthorizationFollowUpRequestSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(priorAuthorizationFollowUpRequestSearchRequest, "PriorAuthorizationFollowUpRequestSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PaFollowUpPaFollowUpPriorAuthorizationFollowUpRequestSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PaFollowUpPaFollowUpPriorAuthorizationFollowUpRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param priorAuthorizationFollowUpResultSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async paFollowUpPriorAuthorizationFollowUpResultSearch (priorAuthorizationFollowUpResultSearchRequest: PriorAuthorizationFollowUpResultSearchRequest, xProgramId?: string): Promise<AxiosResponse<PaFollowUpPaFollowUpPriorAuthorizationFollowUpResultSearchDefaultResponse>> {
        const _url_ = '/edge/paFollowUp/PriorAuthorizationFollowUpResultSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'priorAuthorizationFollowUpResultSearchRequest' is not null or undefined
        if (priorAuthorizationFollowUpResultSearchRequest === null || priorAuthorizationFollowUpResultSearchRequest === undefined) {
            throw new Error('Required parameter priorAuthorizationFollowUpResultSearchRequest was null or undefined when calling paFollowUpPriorAuthorizationFollowUpResultSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(priorAuthorizationFollowUpResultSearchRequest, "PriorAuthorizationFollowUpResultSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PaFollowUpPaFollowUpPriorAuthorizationFollowUpResultSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PaFollowUpPaFollowUpPriorAuthorizationFollowUpResultSearchDefaultResponse");
        }
        return response;
    }
}
